// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import Loading from 'react-loading';
import {
    Chart as ChartJS,
    registerables
} from 'chart.js';
import { Line } from 'react-chartjs-2';

import formatCurrency from '../../utilities/formatCurrency';
import useDarkMode from '../../utilities/darkMode';

import '../../styles/investments.css';

ChartJS.register(...registerables);

const colors = [
    "#00a4f6",
    "#ff4352",
    "#8d43f2",
    "#00b770",
    "#3050f4",
    "#ff6141",
    "#506f79",
    "#ffd04d"
]

export default class LineChart extends React.Component {
    render = () => {
        const dark = useDarkMode(this.props.user);
        return (<div className="investments-chart" style={{...(this.props.styles? this.props.styles : {})}}>
            <h3>{this.props.title}</h3>
            <div
                className="investments-chart-container"
                style={{
                    backgroundColor: this.props.data === undefined ? 'var(--color-menu-raised)' : 'transparent',
                }}
            >
                {this.props.data === undefined ? <div className="investments-chart-loading">
                    <Loading
                        type="bubbles"
                        color="var(--color-primary)"
                        height={32}
                        width={32}
                    />
                </div> : <Line
                    options={{
                        responsive: true,
                        maintainAspectRatio: false,
                        elements: {
                            point: {
                                radius: 0
                            },
                            line: {
                                borderWidth: 1.5
                            }
                        },
                        plugins: {
                            legend: {
                                display: this.props.labels?.length > 1,
                                position: 'right',
                                labels: {
                                    boxWidth: 20,
                                    boxHeight: 0
                                }
                            }
                        },
                        scales: {
                            x: {
                                grid: {
                                    color: 'transparent'
                                }
                            },
                            y: {
                                ...(this.props.yMin !== undefined ? { min: this.props.yMin } : {}),
                                ticks: {
                                    callback: (value, index, values) => formatCurrency(value, 1),
                                    padding: 20
                                },
                                grid: {
                                    color: dark ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.05)'
                                }
                            }
                        }
                    }}
                    data={{
                        labels: ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", 'OCT', 'NOV', 'DEC'],
                        datasets: this.props.labels.map((l,i) => ({
                            fill: true,
                            label: l.label,
                            data: this.props.data.map(d => d[l.key]),
                            borderColor: colors[i%colors.length],
                            backgroundColor: colors[i%colors.length] + '10',
                        }))
                    }}
                />}
            </div>
        </div>);
    }
}